// src/components/Preloader.jsx
import React from "react";
import PropTypes from "prop-types";

const Preloader = ({ fullscreen = true, label = "Loading" }) => {
  return (
    <div
      className={`preloader-activate preloader-active${
        fullscreen ? "" : " preloader-inline"
      }`}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="preloader-area-wrap">
        <div className="spinner d-flex justify-content-center align-items-center h-100">
          <div className="img-loader" aria-hidden="true" />
          <span className="sr-only">{label}…</span>
        </div>
      </div>
    </div>
  );
};

Preloader.propTypes = {
  fullscreen: PropTypes.bool,
  label: PropTypes.string,
};

export default Preloader;
